import { RiEyeLine } from "react-icons/ri";

import Button from "../../Components/Button";

export const config = (onView, withFilter) => [
  {
    name: "Référence",
    selector: (row) => row.reference,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Type de réclamation",
    selector: (row) => row.reclamation_type && row.reclamation_type.name,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Statut",
    sortable: true,
    filterable: withFilter,

    selector: (row) => row.status && row.status.title,
    conditionalCellStyles: [
      {
        when: (row) => row.status && row.status.type === "rejected",
        classNames: ["chip-component danger"],
      },
      {
        when: (row) => row.status && row.status.type === "validated",
        classNames: ["chip-component success"],
      },
      {
        when: (row) => row.status && row.status.type === "in_progress",
        classNames: ["chip-component warning"],
      },
      {
        when: (row) =>
          row.status && row.status.type === "additional_information",
        classNames: ["chip-component primary"],
      },
    ],
  },
  {
    name: "Date de création",
    selector: (row) => row.created_at,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Actions",
    selector: (row) => row.id,
    cell: (row) => (
      <Button
        view="clear"
        variant="dark"
        isIconButton
        title="View"
        onClick={() => onView(row.id)}
      >
        <RiEyeLine />
      </Button>
    ),
  },
];
